import JobNoteCard from './JobNoteCard';
import JobNoteCards from './JobNoteCards';

export {
  JobNoteCard,
  JobNoteCards,
}



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Notes/index.js